function init() {
	(function ($) {
		var timeout_a;

		//customize product quantity input
		$(document).on(
			"click",
			".woocommerce-cart-form button.plus, .woocommerce-cart-form button.minus",
			function () {
				var qty = $(this).parent(".quantity").find(".qty");
				var val = parseFloat(qty.val());
				var max = parseFloat(qty.attr("max"));
				var min = parseFloat(qty.attr("min"));
				var step = parseFloat(qty.attr("step"));

				if ($(this).is(".plus")) {
					if (max && max <= val) {
						qty.val(max);
						qty.attr("value", max);
					} else {
						qty.val(val + step);
						qty.attr("value", val + step);
					}
				} else {
					if (min && min >= val) {
						qty.val(min);
						qty.attr("value", min);
					} else if (val > 1) {
						qty.val(val - step);
						qty.attr("value", val - step);
					}
				}

				if (timeout_a !== undefined) {
					clearTimeout(timeout_a);
				}

				timeout_a = setTimeout(function () {
					$("button[name='update_cart']").prop("disabled", false);
					$("button[name='update_cart']").trigger("click");
					$("button[name='update_cart']").prop("disabled", true);
				}, 500);
			}
		);

		var timeout_b;

		$(document).on(
			"change",
			".woocommerce-cart-form .atk-quantity .qty",
			function () {
				if (timeout_b !== undefined) {
					clearTimeout(timeout_b);
				}

				timeout_b = setTimeout(function () {
					$("button[name='update_cart']").prop("disabled", false);
					$("button[name='update_cart']").trigger("click");
					$("button[name='update_cart']").prop("disabled", true);
				}, 500);
			}
		);

		//enable and disable checkout button
		$(document).on("updated_cart_totals", function () {
			if (
				$(
					".woocommerce-notices-wrapper #isnotsix, .woocommerce-notices-wrapper #isoutofstock"
				).length
			) {
				$("#atk-proceed-to-checkout .checkout-button").css({
					"pointer-events": "none",
					cursor: "not-allowed",
					opacity: "0.7",
				});
				$("#atk-proceed-to-checkout").addClass("disabled");
			} else {
				$("#atk-proceed-to-checkout .checkout-button").css({
					"pointer-events": "auto",
					cursor: "pointer",
					opacity: "1",
				});
				$("#atk-proceed-to-checkout").removeClass("disabled");
			}
		});
	})(jQuery);
}

export default {
	init,
};
